module.exports = __webpack_public_path__ + "static/006_gan-f8f6874f7132aaa019c8f905e0f608a5.jpg";